// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dd-list {
    padding-left: 20px;
  }
  .dd,
  .dd-item,
  .dd-list,
  .dd-placeholder {
    position: relative;
    margin: 0;
    display: block;
  }
  li.dd-item {
    list-style-type: none;
  }
  li.dd-item.expanded {
    list-style-type: none;
  }
  
  .RootToggle{background-color: #f2f3f8;}/* nassar*/
  li.dd-item > a {
    color: #495057;
    display: block;
    /*padding: 0.5rem;*/
    background-color: transparent;
  
    transition: background-color ease 0.4s;
  }
  li.dd-item > a:hover {
    background-color: #f2f3f8;
    border-radius: 0.125rem;
    font-weight: 700;
    cursor: pointer;
  }
  .root-media:hover {
    cursor: pointer;
  }
  .dd-list {
    padding: 5px;
  }
  .item-icon {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #008fc7;
  }
  .item-title {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
  }
  .counter {
    line-height: 1;
    display: inline-flex;
    align-items: center;
    background: #f2f3f8;
    min-width: 24px;
    justify-content: center;
    padding: 2px;
    border-radius: 5px;
  }
  .active-folder {
    background-color: #e1e1e1dc !important;
    border-radius: 0.125rem;
    font-weight: 700;
  }
  
  
  
  `, "",{"version":3,"sources":["webpack://./src/app/new-media/new-media-manager/media-folders/manage-media/move-dialog/move-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;EACpB;EACA;;;;IAIE,kBAAkB;IAClB,SAAS;IACT,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;;EAEA,YAAY,yBAAyB,CAAC,CAAC,UAAU;EACjD;IACE,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,6BAA6B;;IAE7B,sCAAsC;EACxC;EACA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,sCAAsC;IACtC,uBAAuB;IACvB,gBAAgB;EAClB","sourcesContent":[".dd-list {\r\n    padding-left: 20px;\r\n  }\r\n  .dd,\r\n  .dd-item,\r\n  .dd-list,\r\n  .dd-placeholder {\r\n    position: relative;\r\n    margin: 0;\r\n    display: block;\r\n  }\r\n  li.dd-item {\r\n    list-style-type: none;\r\n  }\r\n  li.dd-item.expanded {\r\n    list-style-type: none;\r\n  }\r\n  \r\n  .RootToggle{background-color: #f2f3f8;}/* nassar*/\r\n  li.dd-item > a {\r\n    color: #495057;\r\n    display: block;\r\n    /*padding: 0.5rem;*/\r\n    background-color: transparent;\r\n  \r\n    transition: background-color ease 0.4s;\r\n  }\r\n  li.dd-item > a:hover {\r\n    background-color: #f2f3f8;\r\n    border-radius: 0.125rem;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n  }\r\n  .root-media:hover {\r\n    cursor: pointer;\r\n  }\r\n  .dd-list {\r\n    padding: 5px;\r\n  }\r\n  .item-icon {\r\n    width: 30px;\r\n    height: 30px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 18px;\r\n    color: #008fc7;\r\n  }\r\n  .item-title {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n  }\r\n  .counter {\r\n    line-height: 1;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    background: #f2f3f8;\r\n    min-width: 24px;\r\n    justify-content: center;\r\n    padding: 2px;\r\n    border-radius: 5px;\r\n  }\r\n  .active-folder {\r\n    background-color: #e1e1e1dc !important;\r\n    border-radius: 0.125rem;\r\n    font-weight: 700;\r\n  }\r\n  \r\n  \r\n  \r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
